import React from "react";

import { EventsManagerBody } from "@src/features/eventsManager/EventsManager.body";

export const EventsManagerRoute = () => {
  return <EventsManagerBody />;
};
